module.exports = __webpack_public_path__ + "img/nav_icon_lesson.d15a1ccb.svg";